<template>
  <v-dialog
    v-model="dialog"
    max-width="600px"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" fab depressed small>
        <v-icon>mdi-pencil-outline</v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-form ref="formPersonal" v-model="valid" lazy>
        <v-toolbar flat>
          <v-btn icon dark @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t("profileDialogTitle") }}</v-toolbar-title>
        </v-toolbar>

        <v-card-text class="pb-0">
          <v-select
            v-model="gender.selectGender.id"
            :items="select"
            :rules="[rules.required]"
            item-text="title"
            item-value="id"
            outlined
            :label="$t('profileDialogTreatmentTitle')"
            required
          ></v-select>

          <v-text-field
            v-model="name"
            :label="$t('profileDialogFullName')"
            :rules="[rules.required, rules.nameValid, rules.max]"
            outlined
            required
            :disabled="!exemptPlayer"
          ></v-text-field>
          <v-text-field
            v-if="!exemptPlayer"
            v-model="cpf"
            :label="$t('profileDialogDocument')"
            v-mask="'###.###.###-##'"
            persistent-hint
            outlined
            class="pb-4"
            disabled
          ></v-text-field>
          <v-menu
            v-if="!exemptPlayer"
            ref="menu"
            v-model="menuBirthdate"
            :close-on-content-click="false"
            :nudge-right="0"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                :value="birthdateFormatted"
                :rules="[rules.required, rules.birthdate]"
                :label="$t('profileDialogBirthDate')"
                outlined
                clearable
                readonly
                v-on="on"
                required
                locale="pt-br"
                disabled
              ></v-text-field>
            </template>
            <v-date-picker
              ref="picker"
              v-model="personal.data_nascimento"
              :rules="[rules.required, rules.birthdate]"
              :max="new Date().toISOString().substr(0, 10)"
              min="1950-01-01"
              @change="save"
              locale="pt-br"
            ></v-date-picker>
          </v-menu>
        </v-card-text>

        <v-card-actions class="pa-5">
          <div class="flex-grow-1"></div>

          <v-btn text outlined="" @click="dialog = false">{{
            $t("BtnCancel")
          }}</v-btn>

          <v-btn
            depressed
            type="submit"
            @click.prevent="editUser"
            :disabled="!valid"
            color="primary"
            :loading="loading"
          >
            {{ $t("BtnSave") }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import qs from "qs"; // convert obj in "x-www-form-urlencoded format".
import { validate } from "@/util/form-validate.js";

export default {
  name: "dialogEditPersonal",
  props: ["personal"],
  data: () => ({
    dialog: false,
    dialogTitle: "Editar dados pessoais",
    loading: false,
    valid: true,
    // Rule Select Gender
    gender: {
      selectGender: { id: "1", title: "Sr." },
      // select: [
      //   { id: "1", title: "Sr." },
      //   { id: "2", title: "Sra." },
      // ],
    },
    cpf: "",
    name: "",
    // Rule birthdate
    birthdate: null,
    menuBirthdate: false,
    // Rules Default Import
    rules: {
      required: validate.required,
      nameValid: validate.nameValid,
      max: validate.max,
      docCPF: validate.docCPF,
      birthdate: validate.birthdate,
      validateCPF: validate.validateCPF,
    },
    errorActive: false,
    errorMessage: "",
  }),
  mounted() {
    this.cpf = this.personal.cpf;
    this.name = this.personal.nome;
  },
  computed: {
    birthdateFormatted() {
      return this.personal.data_nascimento
        ? this.$date.format(this.personal.data_nascimento, "DD-MM-YYYY")
        : "";
    },
    select() {
      return [
        { id: "1", title: this.$t("maleTitle") },
        { id: "2", title: this.$t("femaleTitle") },
      ];
    },
    exemptPlayer() {
      return this.$store.state.logged.data.isento_cassino;
    },
  },
  watch: {
    "personal.cpf"(val) {
      this.cpf = val;
    },
    "personal.nome"(val) {
      this.name = val;
    },
    "personal.genero": function(newVal) {
      if (newVal === "1")
        return (this.gender.selectGender = { id: "1", title: "Sr." });
      if (newVal === "2")
        return (this.gender.selectGender = { id: "2", title: "Sra." });
    },

    menuBirthdate(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },

    dialog(val) {
      !val && this.$emit("refresh-user");
    },
    cpf(val) {
      this.errorMessage = "";
      this.errorActive = false;
      if (!val) return;
      const cpf = val.replace(/[\s.-]*/gim, "");
      if (cpf == this.personal.cpf) {
        return;
      }
      if (val.length == 14) {
        this.checkCPF(cpf);
      }
    },
  },
  methods: {
    save(birthdate) {
      this.$refs.menu.save(birthdate);
    },

    checkCPF(cpf) {
      const data = {
        domain: this.$domain(),
        cpf: cpf ? cpf.replace(/[\s.-]*/gim, "") : "",
      };
      this.$axios
        .post("/player/online/register/fetchCpf", this.$formdata(data))
        .then(() => {
          return;
        })
        .catch((error) => {
          this.errorMessage = "CPF já cadastrado!";
          this.errorActive = true;
          this.NotificationErrorDefault(error);
        })
        .finally(() => (this.loading = false));
    },

    // Edit User - Dados Pessoais
    async editUser() {
      if (this.$refs.formPersonal.validate()) {
        this.loading = true;
        const cpf = this.cpf ? this.cpf.replace(/[\s.-]*/gim, "") : "";

        const data = {
          etapa: "Pessoal",
          nome: this.name,
          genero: this.gender.selectGender.id,
          cpf: cpf,
          data_nascimento: this.personal.data_nascimento,
        };

        // Check Email

        // Update Dados Pessoais
        await new Promise((resolve, reject) => {
          this.$axios
            .put("player/profile/editPlayer", qs.stringify(data), {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
              },
            })
            .then((resp) => {
              const msg = resp.data.messages;
              const color = "success";
              this.$store.commit("setNotification", { msg, color });
              this.dialog = false;
              resolve(resp);
            })
            .catch((error) => {
              this.NotificationErrorDefault(error);
              reject(error);
            })
            .finally(() => (this.loading = false));
        });
      }
    },

    // Notification Error Default
    NotificationErrorDefault(error) {
      const msg =
        error.response.data.messages.error || error.response.data.messages[0];
      const color = "warning";
      this.$store.commit("setNotification", { msg, color });
    },
  },
};
</script>
